export { default as CategoriesIndexTableRow } from './CategoriesIndexTableRow';
